<template>
    <form @submit.prevent="submit()">
        <label class="sr-only" for="text">Escribe aquí el mensaje que quieres enviar</label>
        <div class="form-group" :class="{'has-error': errors['text']}">
            <label for="text" class="sr-only">Escribe aquí el mensaje que quieres enviar</label>
            <div class="input-group">
                <input type="text" id="text" class="form-control" v-model="data.text" placeholder="Escribe aquí el mensaje que quieres enviar"/>
                <div class="input-group-btn">
                    <button class="btn btn-primary" type="submit">Enviar</button>
                </div>
            </div>
            <div class="help-block" v-for="e in errors['text']">{{e}}</div>
        </div>
    </form>
</template>
<script>
    export default {
        data: function () {
            return {
                data: {
                    text: ''
                },
                errors: {}
            }
        },
        props: ['page'],
        methods: {
            submit() {
                axios({
                    url: `backend/fichas/${this.page}/messages`,
                    method: 'POST',
                    data: this.data,
                }).then(response => {
                    window.location.replace(response.data.redirect);
                }).catch(error => {
                    this.errors = error.response.data.errors;
                });
            }
        }
    }
</script>